import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, Table } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css"; // Bootstrap Icons
import { EssDasbaord } from "../../../api/Ess/Dasboard";

const AttendanceScreen = () => {
  const [activeFilter, setActiveFilter] = useState("Last 30 Days");
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [apiResponse, setApiResponse] = useState({});
  const [loading, setLoading] = useState(false);
  const [months, setmonths] = useState([]);
  const [selectedMonth ,setSelectedMonth]= useState(new Date().toISOString().slice(0, 7))
  const [monthData, setMonthData] = useState([]);

  const user = JSON.parse(localStorage.getItem("school_user"));
  const { user_detail } = user || {};
  const getCheckinCheckOutData = async (sm = selectedMonth) => {
    setMonthData([]);
    setApiResponse({});
    setLoading(true);
    let data = {
      school_id: user_detail.fk_school_id,
      staff_id: user_detail.staff_id,
      attendance_month: sm || new Date().toISOString().slice(0, 7), // Default to current month if not selected
    };
    const response = await EssDasbaord.my_attendance_overview_ESS(data);
    const res = response.data;
    console.log(res);
    if (res?.status === 200) {
      const trueData = res.data;
      setMonthData(trueData.monthly_attendance[0].attendance_records);
      setApiResponse(trueData);

      const months1 = [
        ...trueData.monthly_attendance.map((item) => item.month),
      ];
      setmonths(months1);
    } else {
    }
  };
  useEffect(() => {
    getCheckinCheckOutData();
  }, []);

  console.log(apiResponse);

  // useEffect(() => {
  //   const filterData = () => {
  //     if (!apiResponse?.monthly_attendance) {
  //       setFilteredRecords([]);
  //       return;
  //     }

  //     if (activeFilter === "Last 30 Days") {
  //       const today = new Date();
  //       const last30Days = new Date(today);
  //       last30Days.setDate(today.getDate() - 30);

  //       // Flatten all attendance records from all months
  //       const allRecords = apiResponse.monthly_attendance.flatMap(
  //         (month) => month.attendance_records || []
  //       );

  //       // Filter only last 30 days
  //       const filtered = allRecords.filter((record) => {
  //         const date = new Date(record.date);
  //         return date >= last30Days && date <= today;
  //       });

  //       setFilteredRecords(filtered);
  //     } else {
  //       const match = apiResponse?.monthly_attendance?.find((month) =>
  //         month.month?.toLowerCase().startsWith(activeFilter.toLowerCase())
  //       );
  //       setFilteredRecords(match ? match.attendance_records : []);
  //     }
  //   };

  //   filterData();
  // }, [apiResponse, activeFilter]);

  const getCurrentStatusText = () => {
    return apiResponse?.current_status?.status === "Check Out"
      ? "Checked Out"
      : "Checked In";
  };


  console.log(apiResponse,"this is response")


  return (
    <Container className="">
      <div className="card-header bg-primary text-white">
        <h5 className="mb-0">Attendance Overview</h5>
      </div>

      <Row className="mb-4 g-3 mt-1">
        <Col md={4}>
          <Card
            className="shadow-sm h-100 text-white text-center"
            style={{ backgroundColor: "#007bffdb", minHeight: "120px" }}
          >
            <Card.Body>
              <h5>
                <i className="bi bi-clock-history mx-1"></i>Login / Logout
              </h5>
              <p className="mb-1">
                Login Time : {apiResponse?.today_attendance?.in_time || "--:--"}
              </p>
              <p>
                Logout Time :{" "}
                {apiResponse?.today_attendance?.out_time || "--:--"}
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card
            className="shadow-sm h-100 text-white text-center"
            style={{ backgroundColor: "#28a745e0", minHeight: "120px" }}
          >
            <Card.Body>
              <h5>
                <i className="bi bi-person-check me-2"></i>Current Status
              </h5>
              <p className="mt-3">{getCurrentStatusText()}</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card
            className="shadow-sm h-100 text-white text-center"
            style={{ backgroundColor: "#17a2b8d4", minHeight: "120px" }}
          >
            <Card.Body>
              <h5>
                <i className="bi bi-hourglass-split me-2"></i>Total Working
                Hours
              </h5>
              <p className="mt-3">
                {apiResponse?.today_attendance?.working_hours || "00:00:00"}
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <hr className="mb-4" />

      <Card className="shadow-sm">
        <Card.Body>
          <div className="row g-3 align-items-end">
            {/* Month Picker */}
            <div className="col-md-4">
              <label className="form-label fw-semibold">
                Select Month-Year
              </label>
              <input
                type="month"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                className="form-control mb-3"
              />
            </div>

            {/* View Button */}
            <div className="">
              <button
                className="btn btn-outline-secondary w-100 mb-3"
                onClick={() => getCheckinCheckOutData(selectedMonth)}
              >
                <i className="bi bi-eye" /> View
              </button>
            </div>
          </div>

          <h5 className="mb-3 page-title">{activeFilter} Attendance</h5>

          {monthData.length > 0 ? (
            <div
              style={{
                maxHeight: "400px",
                overflowY: "auto",
                // add scrollbar
                scrollbarWidth: "thin",
                position: "relative",
              }}
            >
              <Table striped bordered hover responsive className="mb-3">
                <thead className="table  bg-white">
                  <tr>
                    <th>
                      <i className="bi bi-calendar-event mx-1"></i>Date
                    </th>
                    <th>
                      <i className="bi bi-box-arrow-in-right mx-1"></i>Login
                    </th>
                    <th>
                      <i className="bi bi-box-arrow-left mx-1"></i>Logout
                    </th>
                    <th>
                      <i className="bi bi-clock mx-1"></i>Working Hours
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {monthData.map((record, index) => (
                    <tr key={index}>
                      <td>{record.date}</td>
                      <td>{record?.in_time}</td>
                      <td>{record?.out_time}</td>
                      <td>{record?.working_hours}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="text-center text-muted mb-3">No data available</div>
          )}

          <div className="d-flex justify-content-end gap-2">
            {/* <Button variant="success">
              <i className="bi bi-file-earmark-arrow-down me-1"></i>Export
            </Button> */}
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AttendanceScreen;
